import React, {Component} from 'react';
import swal from 'sweetalert';
import {Link} from 'react-router-dom';
import history from '../../history';
import {
	getPackageBookingDetails,
	getPackageBookingConfirmation,
	deletePackageBooking,
	markComplete
} from '../../api/packageBookingApi';
import {set_package_remarks} from '../../api/partnerServiceApi';
import {createServiceTransaction} from '../../api/serviceTransactionApi';
import {fetchTicket} from '../../api/flightApi';
import {downloadTicket, pick} from '../../helpers';
import {Button, ButtonGroup} from 'react-bootstrap';
import {Badge, RemarksForm, PackageRemarksForm} from '../shared';
import {Card, Form} from 'semantic-ui-react';
import moment from 'moment';
import {getAllPartners} from '../../api/partnerApi';

const PAYMENT_METHODS = [
	{ value: 'offline_bank', label: 'Bank transfer' },
	{ value: 'offline_cash', label: 'Cash' },
	{ value: 'offline_cheque', label: 'Cheque' }
];

class PackageBookingDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			partners: [],
			user_remarks: [],
			vendor_remarks: [],
			isRemarksFormOpen: false,
			recordPaymentOpen: false,
			recordPaymentForm: { amount: '', payment_mode: 'offline_bank', receipt_no: '', remarks: '' },
			recordPaymentFor: null,
			recording: false,
			packageBooking: {
				user_remarks: [],
				booking_transaction: {},
				inquiry: {},
				package: {},
				vendor_services: []
			}
		};
	}

	fetchDetails = () => {
		getPackageBookingDetails(this.props.match.params.idx).then((v) => {
			this.setState({
				packageBooking: v.data,
				user_remarks: v.data.user_remarks,
				vendor_remarks: v.data.vendor_remarks
			});
		});
	};

	componentDidMount() {
		this.fetchDetails();
		getAllPartners({ q: { status_eq: 'approved', for_assignment_type: 'PartnerService' }, per_page: 500 }).then((response) => {
			const list = (response.data && (Array.isArray(response.data) ? response.data : response.data.partners || response.data.vendors)) || [];
			this.setState({ partners: list });
		}).catch(() => this.setState({ partners: [] }));
	}

	openRecordPayment = (ps) => {
		const amount = (ps.amount != null && ps.amount > 0) ? String(Number(ps.amount).toFixed(0)) : '';
		this.setState({ recordPaymentOpen: true, recordPaymentFor: ps, recordPaymentForm: { amount, payment_mode: 'offline_bank', receipt_no: '', remarks: '' } });
	};
	closeRecordPayment = () => this.setState({ recordPaymentOpen: false, recordPaymentFor: null });
	recordPaymentSubmit = () => {
		const { recordPaymentFor, recordPaymentForm } = this.state;
		const amount = Number(recordPaymentForm.amount);
		if (!recordPaymentFor || !recordPaymentFor.vendor_id || !amount || amount <= 0) {
			swal('Invalid', 'Amount is required and must be greater than 0.', 'info');
			return;
		}
		this.setState({ recording: true });
		createServiceTransaction({
			vendor_id: recordPaymentFor.vendor_id,
			direction: 'debit',
			amount,
			assignment_type: 'PartnerService',
			assignment_idx: recordPaymentFor.idx,
			payment_mode: recordPaymentForm.payment_mode,
			receipt_no: recordPaymentForm.receipt_no || undefined,
			remarks: recordPaymentForm.remarks || undefined
		})
			.then(() => {
				swal('Recorded', 'Payment recorded for this assignment. Vendor balance updated.', 'success');
				this.closeRecordPayment();
				this.fetchDetails();
			})
			.catch((e) => swal('Error', (e.response && e.response.data && e.response.data.errors) ? e.response.data.errors.join(' ') : 'Failed to record payment', 'error'))
			.finally(() => this.setState({ recording: false }));
	};

	// onConfirmPackageBooking(id) {
	// 	getPackageBookingConfirmation(id)
	// 		.then((response) => {
	// 			swal({
	// 				title: 'Package Booking Confirmation!',
	// 				text: response.data.message,
	// 				icon: 'success',
	// 				button: 'Continue!'
	// 			});
	// 		})
	// 		.catch((error) => {
	// 			console.log('Package booking confirmation error', error);
	// 		});
	// }

	destroyPackageBooking(id) {
		swal({
			title: 'Are you sure?',
			text: 'Once deleted, this private tour booking will be removed',
			icon: 'warning',
			buttons: true,
			dangerMode: true
		}).then((willDelete) => {
			if (willDelete) {
				deletePackageBooking(id).then((response) => {
					swal('This private tour booking has been deleted', {
						icon: 'success'
					});
					history.push('/admin/package_booking');
				});
			} else {
				swal('Private tour booking was not deleted');
			}
		});
	}

	download = (idx) => {
		fetchTicket(idx).then((response) => {
			this.setState({
				loading: false
			});
			downloadTicket(response.data);
		});
	};

	onMarkComplete(id) {
		markComplete(id)
			.then((response) => {
				swal({
					title: 'Response',
					text: response.data.message,
					icon: response.status == 200 ? 'success' : 'error'
				}).then((response) => {
					history.push('/admin/package_booking');
				});
			})
			.catch((v) => {});
	}

	render() {
		const {packageBooking, partners, user_remarks, vendor_remarks} = this.state;
		const packageInfo = pick(packageBooking.package, ['name']);
		const contactInfo = pick(packageBooking.inquiry, [
			'first_name',
			'last_name',
			'email_address',
			'address',
			'city',
			'head_traveller_name',
			'nationality',
			'number_of_adult',
			'number_of_child',
			'phone',
			'query'
		]);

		const bookingInfo = pick(packageBooking, ['pickup_location', 'drop_off_location']);
		const booleans = pick(packageBooking, ['meals_included']);

		const bookingDateInfo = pick(packageBooking, ['start_date', 'end_date', 'pickup_date', 'drop_off_date']);
		const otherInfo = pick(packageBooking, ['idx']);
		const {loading} = this.state;
		return (
			<div className='container'>
				<Card fluid>
					<Card.Content>
						<div className='ui segment'>
							<h3 className='ui header'> Booking Details </h3>
							{packageBooking.package && packageBooking.package.vendor_id && (
								<div className='alert alert-info mb-3'>
									<strong>Assigned to {packageBooking.package.vendor_company_name || `Vendor #${packageBooking.package.vendor_id}`}</strong>
									<p className='text-muted small mb-0 mt-1'>This listing belongs to this vendor and cannot be reassigned.</p>
								</div>
							)}
							<div className='ui internally celled stackable grid section-layout'>
								<div className='row'>
									<div className='eight wide column section'>
										<h3 className='ui header'> Private tour info </h3>
										<div className='ui grid'>
											{Object.entries(packageInfo).map(([key, value]) => (
												<div className='row'>
													<div className='eight wide column'>{key.titleize()}:</div>
													<div className='eight wide column'>{value}</div>
												</div>
											))}
											<div className='row'>
												<div className='eight wide column'>
													<h3 className='ui header'> Inquiry Details </h3>
												</div>
												<div className='eight wide column right floated'>
													<div
														className='ui basic button right aligned'
														onClick={() =>
															history.push(
																`/admin/inquiry_details/${packageBooking.inquiry.idx}`
															)}
													>
														View
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className='eight wide column section'>
										<h3 className='ui header'> Contact Info </h3>
										<div className='ui grid'>
											{Object.entries(contactInfo).map(([key, value]) => (
												<div className='row'>
													<div className='eight wide column'>{key.titleize()}:</div>
													<div className='eight wide column'>{value}</div>
												</div>
											))}
										</div>
									</div>
								</div>
								<div className='row'>
									<div className='eight wide column section'>
										<h3 className='ui header'> Booking Info </h3>
										<div className='ui grid'>
											{Object.entries(bookingInfo).map(([key, value]) => (
												<div className='row'>
													<div className='eight wide column'>{key.titleize()}:</div>
													<div className='eight wide column'>{value}</div>
												</div>
											))}
											{Object.entries(booleans).map(([key, value]) => (
												<div className='row'>
													<div className='eight wide column'>{key.titleize()}:</div>
													<div className='eight wide column'>
														{value ? 'Included' : 'Not Included'}
													</div>
												</div>
											))}
											{Object.entries(bookingDateInfo).map(([key, value]) => (
												<div className='row'>
													<div className='eight wide column'>{key.titleize()}:</div>
													<div className='eight wide column'>
														{moment(value).format('D MMMM, YYYY')}
													</div>
												</div>
											))}
											{packageBooking.inquiry &&
												packageBooking.inquiry.addons &&
												packageBooking.inquiry.addons.map((addon) => {
													return (
														<div className='row'>
															<div className='eight wide column'>Name</div>
															<div className='eight wide column'>{addon.name}</div>
															<div className='eight wide column'>Count</div>
															<div className='eight wide column'>{addon.count}</div>
															<div className='eight wide column'>Price</div>
															<div className='eight wide column'>{addon.price}</div>
														</div>
													);
												})}
										</div>
									</div>
									<div className='eight wide column section'>
										<h3 className='ui header'> Other Info </h3>
										<div className='ui grid'>
											{Object.entries(otherInfo).map(([key, value]) => (
												<div className='row'>
													<div className='eight wide column'>{key.titleize()}:</div>
													<div className='eight wide column'>{value}</div>
												</div>
											))}
											<div className='row'>
												<div className='eight wide column'>Status:</div>
												<div className='eight wide column'>
													<Badge type={packageBooking.status}>{packageBooking.status}</Badge>
												</div>
											</div>

											<div className='row'>
												<div className='eight wide column'>Details:</div>
												<div className='eight wide column'>{packageBooking.details}</div>
											</div>

											<div className='row'>
												<div className='eight wide column'>User Remarks:</div>
												<div className='eight wide column'>{packageBooking.user_remarks}</div>
											</div>

											{packageBooking.vendor_services && packageBooking.vendor_services.length > 0 && (
												<div className='row'>
													<div className='column'>
														<h4 className='ui header'>Vendor assignments</h4>
														{packageBooking.vendor_services.map((ps) => {
															const p = partners.find((x) => x.id == ps.vendor_id) || {};
															const name = p.company_name || [p.first_name, p.last_name].filter(Boolean).join(' ') || `Vendor #${ps.vendor_id}`;
															return (
																<div key={ps.idx || ps.id} className='mb-3 p-2 bg-light rounded'>
																	<strong>{name}</strong>
																	{ps.amount != null && ps.amount > 0 && <span className='ml-2 text-muted'>Vendor share {formatMoneyLegacy(ps.amount, cc)}</span>}
																	{ps.vendor_completed_at ? (
																		<span className='ml-2 badge badge-success'>Vendor marked complete · {moment(ps.vendor_completed_at).format('D MMM YYYY, h:mm a')}</span>
																	) : (
																		<span className='ml-2 badge badge-warning'>Pending vendor confirmation</span>
																	)}
																	<span className='ml-2'>Paid to vendor for this assignment: <strong>{formatMoneyLegacy(ps.vendor_paid_total != null ? ps.vendor_paid_total : 0, cc)}</strong></span>
																	{(ps.amount != null && ps.vendor_paid_total != null && Number(ps.vendor_paid_total) >= Number(ps.amount)) ? (
																		<span className='badge badge-success ml-2'>Paid</span>
																	) : (
																		<button type='button' className='btn btn-outline-success btn-sm ml-2' onClick={() => this.openRecordPayment(ps)} disabled={!!this.state.recording}>Record payment (this assignment)</button>
																	)}
																</div>
															);
														})}
														<p className='text-muted small mt-1 mb-0'>Or pay from <Link to='/admin/summaries'>Vendor Payouts</Link>.</p>
													</div>
												</div>
											)}

											<div className='row'>
												<div className='column'>
													<PackageRemarksForm
														remarks={packageBooking.vendor_remarks}
														partners={partners}
														vendor_services={packageBooking.vendor_services}
														onSubmit={(data) => {
															set_package_remarks(data.idx, {
																vendor_remarks: data.value
															}).then((v) => {});
														}}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Card.Content>
				</Card>
				<div className='text-center py-4'>
					{packageBooking.inquiry.status === 'verified' && (
						<Button
							primary
							loading={loading}
							className='btn btn-primary btn-large '
							onClick={() => this.download(packageBooking.idx)}
						>
							Download ticket
						</Button>
					)}
					{packageBooking.status === 'verified' && (
						<span
							className='btn btn-primary btn-large ml-2 '
							onClick={() => this.onMarkComplete(packageBooking.idx)}
						>
							Mark As Complete
						</span>
					)}
					{/* {packageBooking.inquiry.status == 'pending' && (
						<span
							className='btn btn-secondary btn-large ml-3'
							onClick={() => this.onConfirmPackageBooking(packageBooking.idx)}
						>
							confirm
						</span>
					)} */}
					{/* <span
						className='btn bg-none text-danger'
						onClick={() => this.destroyPackageBooking(packageBooking.idx)}
					>
						Delete
					</span> */}
				</div>

				{this.state.recordPaymentOpen && this.state.recordPaymentFor && (
					<div className='modal fade show d-block' style={{ background: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
						<div className='modal-dialog modal-dialog-centered'>
							<div className='modal-content'>
								<div className='modal-header'>
									<h5 className='modal-title'>Record payment to vendor (this assignment)</h5>
									<button type='button' className='close' onClick={this.closeRecordPayment}><span>&times;</span></button>
								</div>
								<div className='modal-body'>
									<p className='text-muted small'>This payment will be linked to this private tour assignment. Vendor share: {formatMoneyLegacy(this.state.recordPaymentFor.amount != null ? this.state.recordPaymentFor.amount : 0, this.state.packageBooking.package?.currency_code || this.state.packageBooking.currency_code || 'NPR')}.</p>
									<div className='form-group'>
										<label>Amount *</label>
										<input type='number' min={0.01} step={0.01} className='form-control' value={this.state.recordPaymentForm.amount} onChange={(e) => this.setState({ recordPaymentForm: { ...this.state.recordPaymentForm, amount: e.target.value } })} placeholder='0' />
									</div>
									<div className='form-group'>
										<label>Payment method</label>
										<select className='form-control' value={this.state.recordPaymentForm.payment_mode} onChange={(e) => this.setState({ recordPaymentForm: { ...this.state.recordPaymentForm, payment_mode: e.target.value } })}>
											{PAYMENT_METHODS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
										</select>
									</div>
									<div className='form-group'>
										<label>Receipt / Reference no.</label>
										<input type='text' className='form-control' value={this.state.recordPaymentForm.receipt_no} onChange={(e) => this.setState({ recordPaymentForm: { ...this.state.recordPaymentForm, receipt_no: e.target.value } })} placeholder='Optional' />
									</div>
									<div className='form-group'>
										<label>Remarks</label>
										<input type='text' className='form-control' value={this.state.recordPaymentForm.remarks} onChange={(e) => this.setState({ recordPaymentForm: { ...this.state.recordPaymentForm, remarks: e.target.value } })} placeholder='Optional' />
									</div>
								</div>
								<div className='modal-footer'>
									<button type='button' className='btn btn-secondary' onClick={this.closeRecordPayment}>Cancel</button>
									<button type='button' className='btn btn-primary' onClick={this.recordPaymentSubmit} disabled={!!this.state.recording || !this.state.recordPaymentForm.amount}>Record payment</button>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default PackageBookingDetails;
